import React from "react"
import { connect } from "react-redux"
import { push } from "connected-react-router"
import PropTypes from "prop-types"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer } from "react-google-maps"
import { getZoom, getRegionForCoordinates } from "../transportation"

class GogleMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      directions: '',
      bounds: ''
    }
  }

  componentDidMount() {
    const {originCoords, destinationCoords} = this.props
    if (originCoords && destinationCoords) this.getDirectionsData(originCoords, destinationCoords)
    else if (originCoords) this.setPanTo(originCoords)
    else if (destinationCoords) this.setPanTo(destinationCoords)
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    const {originCoords, destinationCoords} = this.props

    if (originCoords && destinationCoords && (originCoords != prevProps.originCoords ||  destinationCoords != prevProps.destinationCoords)) this.getDirectionsData(originCoords, destinationCoords)
    else if (originCoords != prevProps.originCoords) this.setPanTo(originCoords)
    else if (destinationCoords != prevProps.destinationCoords) this.setPanTo(destinationCoords)
  }

  setPanTo(coords) {
    const panTo = {lat: coords[0], lng: coords[1]}
    this.setState({panTo})
  }

  getDirectionsData(originCoords, destinationCoords) {
    const DirectionsService = new google.maps.DirectionsService();

    const originLatLng = {lat: originCoords[0], lng: originCoords[1]}
    const destinationLatLng = {lat: destinationCoords[0], lng: destinationCoords[1]}
    DirectionsService.route({
      origin: new google.maps.LatLng(originLatLng),
      destination: new google.maps.LatLng(destinationLatLng),
      travelMode: google.maps.TravelMode.DRIVING,
    }, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        this.setState({
          directions: result, 
        });
      }
      else {
        console.error(`error fetching directions ${result}`);
      }
    })
  }


  getMapCenter() {
    const {originCoords, destinationCoords, city} = this.props
    if (originCoords && destinationCoords) return getRegionForCoordinates([originCoords, destinationCoords]).latlng
    else if (originCoords) return originCoords
    else if (destinationCoords) return destinationCoords
    else if (this.props.cities[city]) return [this.props.cities[city].preciseLocation.latitude, this.props.cities[city].preciseLocation.longitude]
    else return [this.props.cities.Madrid.preciseLocation.latitude, this.props.cities.Madrid.preciseLocation.longitude]
  }
  
  getMapZoom() {
    const {originCoords, destinationCoords} = this.props
    if (originCoords && destinationCoords) {
      return getZoom(originCoords, destinationCoords)
    }
    else return originCoords ? 16.5 : 11.5
  }

  render() {
    const {city = "Madrid", cities, originCoords, destinationCoords} = this.props
    
    const googleMap = <GoogleMap
      ref={(ref) => { this.map = ref }}
      defaultZoom={16}
      options={{
        disableDefaultUI: true,
        ...(this.props.disableDragging 
          ? { draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true }
          : {}
        )
      }}
      defaultCenter={new google.maps.LatLng(cities[city].preciseLocation.latitude, cities[city].preciseLocation.longitude)}

    > 
      {!this.state.directions && originCoords && (
        <Marker
          position={{ lat: originCoords[0], lng: originCoords[1] }}
        />
      )}
      {!this.state.directions && destinationCoords && (
        <Marker
          position={{ lat: destinationCoords[0], lng: destinationCoords[1] }}
        />
      )}
      {this.state.panTo && !this.state.directions && this.map && this.map.panTo(this.state.panTo)} 
      {this.state.directions && <DirectionsRenderer directions={this.state.directions} />}  
    </GoogleMap>

    return googleMap
  }
}

GogleMap.propTypes = {
  originCoords: PropTypes.array.isRequired,
  destinationCoords: PropTypes.array.isRequired,
  city: PropTypes.string.isRequired,
  fetchingCoords: PropTypes.bool.isRequired,
  cities:PropTypes.string.isRequired,
  disableDragging: PropTypes.bool
}

GogleMap.defaultProps = {
  disableDragging: false
}

const mapStateToProps = (state, ownProps) => ({})


const mapDispatchToProps = (dispatch, _ownProps) => ({
  push: (url) => dispatch(push(url)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withScriptjs(withGoogleMap(GogleMap)))


// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/GoogleMap.jsx